<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="$t('news.text0')"></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<div class="swiper_el"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img class="bg" src="../../assets/img_public/news/banner01.webp" />
				</div>
				<div class="nav_bot">
					<div class="nav_bot_main">
						<div class="left"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="400"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div
								v-for="(value, index) in navList"
								:key="index"
								class="left_el"
								:class="isActived == index ? 'actived' : ''"
								@click="navChange(index)"
							>
								{{ value.title }}
								<div class="line"></div>
							</div>
						</div>
						<div class="right"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="400"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<van-icon name="wap-home-o" size="20px" color="#ffffff" style="position: relative;top: 4px;" />&nbsp;
							<span style="cursor: pointer;" @click="goHome">{{ $t('news.text1') }}</span>&ensp;
							<van-icon name="arrow" size="20px" color="#ffffff" style="position: relative;top: 4px;" />&ensp;
							<span>{{ $t('news.text0') }}</span>
						</div>
					</div>
				</div>
			</div>
			<!--banner-->
			<!--公司动态-->
			<template v-if="isActived == 0">
				<gsdt></gsdt>
			</template>
			<!--公司动态-->
			<!--行业资讯-->
			<template v-if="isActived == 1">
				<hyzx></hyzx>
			</template>
			<!--行业资讯-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import gsdt from './gsdt/index_pc.vue'  //公司动态
import hyzx from './hyzx/index_pc.vue'  //行业资讯
export default {
	components:{
		navBox,
		footerBox,
		gsdt,
		hyzx
	},
	data() {
		return {
			isLoading: true,  //界面loading
			navList: [],
			isActived: 0,
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navList')) {
			that.navList = JSON.parse(sessionStorage.getItem('navList'))[3].children;
			switch(that.$route.params.newsId) {
				case 'dynamics.html':
					that.isActived = 0;
				break;
				case 'introduction.html':
					that.isActived = 1;
				break;
			}
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击首页
		goHome() {
			this.$router.push({ path: '/' });
		},
		//nav变化
		navChange(index) {
			let that = this;
			that.isActived = index;
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	.banner_box{
		min-width: 1200px;
		position: relative;
		.nav_bot{
			position: absolute;
			width: 100%;
			bottom: 0;
			border-top: 1px solid #ECE7E8;
			overflow: hidden;
			.nav_bot_main{
				display: flex;
				align-items: center;
				width: 1264px;
				margin: 0 auto;
				padding: 40px 0;
				color: #ffffff;
				.left{
					flex: 1;
					.left_el{
						display: inline-block;
						padding: 0 40px;
						border-right: 1px solid #ffffff;
						line-height: 1;
						cursor: pointer;
						position: relative;
						font-size: 18px;
						.line{
							position: absolute;
							width: 30px;
							height: 4px;
							bottom: -8px;
							left: 50%;
							transform: translate(-50%, 0);
							border-radius: 4px;
							background-color: transparent;
						}
					}
					.left_el.actived{
						font-weight: bold;
						.line{
							background-color: #A50073;
						}
					}
					.left_el:first-child{
						padding-left: 0;
						.line{
							left: 30%;
							transform: translate(-15%, 0);
						}
					}
					.left_el:last-child{
						border-right: none;
					}
				}
				.right{
					width: auto;
					span{
						font-size: 18px;
					}
				}
			}
		}
		.swiper_el{
			position: relative;
			.msg_box{
				width: 1264px;
				margin: 0 auto;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				color: #ffffff;
				.tit{
					margin-top: 20px;
					font-size: 18px;
				}
				.tit_b{
					font-size: 42px;
					font-weight: bold;
				}
			}
			img.bg{
				width: 100%;
			}
		}
	}
}
</style>